import intl from "react-intl-universal";

import type {RootStoreModel} from "@stores/RootStore";

import {updateLocale} from "../utils/LocaleLoader";


export const initLocale = (rootStore: RootStoreModel) => {
    let currentLocale = window.localStorage.getItem('locale');

    if (!currentLocale) {
        currentLocale = intl.determineLocale({
            urlLocaleKey: "lang",
            cookieLocaleKey: "lang"
        }) || 'en-US';
    }

    return setLocale(rootStore, currentLocale);
};


export const setLocale = (rootStore: RootStoreModel, newLocale: string) => {
    return updateLocale(newLocale).then(() => {
        rootStore.setCurrentLocale(newLocale);
        localStorage.setItem('locale', newLocale);
    })
}